// extracted by mini-css-extract-plugin
export default {"RouteWrapper":"styles_RouteWrapper__fD5SC","RouteWrapperContent":"styles_RouteWrapperContent__rcEAd"};